<nav class="navbar navbar-expand box-shadow">
  <a class="navbar-brand">SMART E-TAX</a>
  <div class="collapse navbar-collapse" id="navbarSupportedContent">
    <ul class="navbar-nav mr-auto"></ul>
    <ul class="navbar-nav align-middle">
      <div ngbDropdown placement="bottom-right" id="userArea" class="d-inline-block align-middle text-white">
        <select class="form-control form-control-sm language-switcher" style="vertical-align: middle;
          width: auto; height: auto ;display: inline" (change)="changeLanguage()" [(ngModel)]="language">
          <option value="en">&nbsp;EN</option>
          <option value="th">&nbsp;TH</option>
        </select>
      </div>
    </ul>
  </div>
</nav>
<div class="container">
  <div class="row mt-3">
    <div class="col-12">
      <h3 class="text-center">
        {{ 'CUSTOMER-REQUEST.TAX-INVOICE-REQUEST' | translate}}
      </h3>
    </div>
  </div>
  <div [formGroup]="buyerRequestForm" class="position-relative row">
    <div class="col-md-6 mt-3">
      <div class="box-content">
        <h4 class="title">
          {{ 'CUSTOMER-REQUEST.REQUEST-DETAIL' | translate}}
        </h4>
      </div>
      <div class="box-content mt-3 box-content-size">
        <div class="row">
          <h5 class="title ml-3">
            {{ 'CUSTOMER-REQUEST.BILL-DETAIL' | translate}}
          </h5>
        </div>

        <div class="mt-2">
          <p-radioButton class="dv-checkbox"
              name="type"
              value="hotel"
              inputID="type_hotel"
              label="{{ 'CUSTOMER-REQUEST.HOTEL-ROOM' | translate}}"
              formControlName="type"
              (click)="handleDocTypeButton()">
          </p-radioButton>
          <p-radioButton class="dv-checkbox ml-4"
              name="type"
              value="dinning"
              inputID="type_dinning"
              label="{{ 'CUSTOMER-REQUEST.DINNING-ROOM' | translate}}"
              formControlName="type"
              (click)="handleDocTypeButton()">
          </p-radioButton>
          <p-radioButton class="dv-checkbox ml-4"
              name="type"
              value="spa"
              inputID="type_spa"
              label="{{ 'CUSTOMER-REQUEST.SPA' | translate}}"
              formControlName="type"
              (click)="handleDocTypeButton()">
          </p-radioButton>
        </div>
        <div>
          <div class="row">
            <div class="col-12">
              <label [ngClass]="{'required': !documentRequestSpaType()}" for="abb-no">
                {{ (documentRequestSpaType() ? 'FILTER.BILLING-NO' : 'FILTER.ABB-NO') | translate }}
              </label>
            </div>
            <div *ngIf="documentRequestSpaType()" class="col-12">
              <input class="form-control" type="text" formControlName="billingNo">
            </div>
            <div *ngIf="!documentRequestSpaType()" class="col-12">
              <input class="form-control w-30percent d-inline" type="text" formControlName="abbNo01">
              <span> - </span>
              <input class="form-control w-30percent d-inline" type="text" formControlName="abbNo02">
              <span> - </span>
              <input class="form-control w-30percent d-inline" type="text" formControlName="abbNo03">
              <div *ngIf="invalidAbbNo && showError">
                <span class="text-danger text-left">{{ 'ERROR.REQUIRED' | translate }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="box-content mt-3 box-content-size">
        <h5 class="title">
          {{ 'CUSTOMER-REQUEST.CUSTOMER-DETAIL' | translate}}
        </h5>
        <div class="row align-items-start">
          <div class="col-md-6">
            <div class="row">
              <div class="col-12">
                <label for="tax-id" [class.required]="isThailand">{{ 'CUSTOMER-REQUEST.TAX-ID' | translate }}</label>
              </div>
              <div class="col-12">
                <input class="form-control" type="text" id="tax-id" formControlName="taxID" (input)="taxIDChange($event)">

                <div *ngIf="form.taxID.errors?.required && showError && isThailand">
                  <span class="text-danger text-left">{{ 'ERROR.REQUIRED' | translate }}</span>
                </div>

                <div *ngIf="form.taxID.errors?.taxIDInvalid && showError && isThailand">
                  <span class="text-danger text-left">{{ 'ERROR.INVALID-THAI-TAXID' | translate }}</span>
                </div>
              </div>
            </div>
          </div>
          <div class="col-md-6">
            <div class="row">
              <div class="col-12">
                <label for="name" class="required">{{ 'CUSTOMER-REQUEST.NAME' | translate}}</label>
              </div>
              <div class="col-12">
                <input class="form-control" type="text" id="name" formControlName="name">
                <div *ngIf="form.name.errors?.required && showError">
                  <span class="text-danger text-left">{{ 'ERROR.REQUIRED' | translate }}</span>
                </div>
              </div>
            </div>
          </div>
          <div class="col-md-6">
            <div class="row">
              <div class="col-12">
                <label for="branch-code">{{ 'CUSTOMER-REQUEST.BRANCH-CODE' | translate}}</label>
              </div>
              <div class="col-12">
                <input class="form-control" type="text" id="branch-code" formControlName="branchCode">
              </div>
            </div>
          </div>
          <div class="col-md-6">
            <div class="row">
              <div class="col-12">
                <label for="branch-name">{{ 'CUSTOMER-REQUEST.BRANCH-NAME' | translate}}</label>
              </div>
              <div class="col-12">
                <input class="form-control" type="text" id="branch-name" formControlName="branchName">
              </div>
            </div>
          </div>
          <div class="col-md-6">
            <div class="row">
              <div class="col-12">
                <label for="address" class="required">{{ 'CUSTOMER-REQUEST.ADDRESS' | translate}}</label>
              </div>
              <div class="col-12">
                <textarea class="form-control" id="address" rows="4" formControlName="address"></textarea>
                <div *ngIf="form.address.errors?.required && showError">
                  <span class="text-danger text-left">{{ 'ERROR.REQUIRED' | translate }}</span>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-12">
                <label for="postcode" [ngClass]="{'required': form.postcode.validator}">{{ 'CUSTOMER-REQUEST.POSTCODE' | translate}}</label>
              </div>
              <div class="col-12">
                <input class="form-control" type="text" id="postcode" formControlName="postcode">
                <div *ngIf="form.postcode.errors?.postalCodeInvalid && showError">
                  <span class="text-danger text-left">{{ 'ERROR.INVALID' | translate }}</span>
                </div>
              </div>
            </div>
          </div>

          <div class="col-md-6">
            <div class="row">
              <div class="col-12">
                <label for="subDistrict" class="required">{{ 'CUSTOMER-REQUEST.SUB-DISTRICT' | translate}}</label>
              </div>
              <div class="col-12">
                <input class="form-control" type="text" id="subDistrict" formControlName="subDistrict">
              </div>
            </div>
            <div class="row">
              <div class="col-12">
                <label for="district" class="required">{{ 'CUSTOMER-REQUEST.DISTRICT' | translate}}</label>
              </div>
              <div class="col-12">
                <input class="form-control" type="text" id="district" formControlName="district">
              </div>
            </div>
            <div class="row">
              <div class="col-12">
                <label for="province" class="required">{{ 'CUSTOMER-REQUEST.PROVINCE' | translate}}</label>
              </div>
              <div class="col-12">
                <input class="form-control" type="text" id="province" formControlName="province">
              </div>
            </div>
          </div>

          <div class="col-md-12">
            <div class="row">
              <div class="col-12">
                <label for="country" class="required">{{ 'CUSTOMER-REQUEST.COUNTRY' | translate}}</label>
              </div>
              <div class="col-12">
                <ng-select class="custom"
                    [items]="countries"
                    labelForId="buyer-country"
                    [bindLabel]="translate.currentLang === 'en' ? 'country_name':'country_name_th'"
                    bindValue="id"
                    placeholder="{{'FILTER.PLACEHOLDER' | translate}}"
                    [clearable]="false"
                    formControlName="country"
                    (change)="countryChange($event)"
                    *ngIf="!refreshDropdown">
                </ng-select>
                <div *ngIf="form.country.errors?.required && showError">
                  <span class="text-danger text-left">{{ 'ERROR.REQUIRED' | translate }}</span>
                </div>
              </div>
            </div>
          </div>
          <div class="col-md-6">
            <div class="row">
              <div class="col-12">
                <label for="email" class="required">{{ 'CUSTOMER-REQUEST.EMAIL' | translate}}</label>
              </div>
              <div class="col-12">
                <input class="form-control" type="text" id="email" formControlName="email">
                <div *ngIf="form.email.errors?.required && showError">
                  <span class="text-danger text-left">{{ 'ERROR.REQUIRED' | translate }}</span>
                </div>
                <div *ngIf="form.email.errors?.email && showError">
                  <span class="text-danger text-left">{{ 'ERROR.INVALID' | translate }}</span>
                </div>
              </div>
            </div>
          </div>
          <div class="col-md-6">
            <div class="row">
              <div class="col-12">
                <label for="cc-email">{{ 'CUSTOMER-REQUEST.CC-EMAIL' | translate}}</label>
              </div>
              <div class="col-12">
                <input class="form-control" type="text" id="cc-email" formControlName="ccEmail">
              </div>
            </div>
          </div>
          <div class="col-md-12">
            <div class="row">
              <div class="col-12">
                <label for="phone-number" class="required">{{ 'CUSTOMER-REQUEST.PHONE-NUMBER' | translate}}</label>
              </div>
              <div class="col-12">
                <input class="form-control" type="text" id="phone-number" formControlName="phoneNumber"
                (keyup)="formatPhoneNumber($event)"
                (keypress)='charValidate($event)'>
                <div *ngIf="form.phoneNumber.errors?.required && showError">
                  <span class="text-danger text-left">{{ 'ERROR.REQUIRED' | translate }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="my-4 text-center">
        <div *ngIf="showError && !buyerRequestForm.valid" class="mb-2">
          <span class="text-danger text-left">{{ 'ERROR.TAIL-REPORT' | translate }}</span>
        </div>
        <button class="btn btn-dv btn-wide m-r-5" (click)="onSubmit(confirmationpopup)">
          <i *ngIf="loading" class="fa fa-spinner fa-spin m-r-5"></i>
          {{ 'CUSTOMER-REQUEST.SUBMIT-REQUEST' | translate}}
        </button>
      </div>
    </div>
    <div class="col-md-6 mt-3">
      <div class="box-content mb-3 text-center">
        <img *ngIf="form.type.value === 'dinning'" src="../../../assets/images/sample-abb.png" alt="sample-abb.png"
          class="mr-4 img-pdf">
        <img *ngIf="form.type.value === 'hotel'" src="../../../assets/images/sample-confirmation.png" alt="sample-confirmation.png"
          class="mr-4 img-pdf">
        <img *ngIf="form.type.value === 'spa'" src="../../../assets/images/sample-spa.png" alt="sample-spa.png"
          class="mr-4 img-pdf">
      </div>
    </div>
  </div>
</div>
<!-- Confirmation Popup -->
<ng-template #confirmationpopup
    let-modal>
  <div class="modal-header">
    <h5 class="modal-title">{{ 'CUSTOMER-REQUEST.TITLE' | translate }}</h5>
    <button type="button"
        class="close"
        aria-label="Close"
        (click)="closePopup()">
      <span aria-hidden="true">&times;</span>
    </button>
    </div>
    <div class="modal-body">
      <div class="w-100percent d-flex justify-content-center">
        <span *ngIf="language === 'th'"
            style="display: flow;">
          ทางโรงแรมคาเพลลา กรุงเทพ (บริษัท วอเตอร์ฟร้อนท์ โฮเต็ล จำกัด สาขาที่ 00001)
          ขออนุญาตดำเนินการตามสิทธิประโยชน์สำหรับการลดหย่อนภาษีตามประกาศของกรมสรรพากรปี 2567
          ทางโรงแรมฯ ใคร่ขอความร่วมมือกับแขกผู้ใช้บริการให้ความยินยอมในการเปิดเผยข้อมูลของท่านกับทางโรงแรมฯและกรมสรรพากร
          <br /><br />
          โดยสามารถอ่านรายละเอียดนโยบายความเป็นส่วนตัวเพิ่มเติมที่
          <a href="https://capellahotelgroup.com/privacy-policy/">https://capellahotelgroup.com/privacy-policy/
          </a>
          <br /><br />
          กรุณากด "ตกลง" เพื่อดำเนินการออกใบกำกับภาษีในลำดับต่อไป
        </span>
        <span *ngIf="language !== 'th'"
            style="display: flow;">
          Capella Bangkok (Waterfront Hotel Co., Ltd. Branch 00001) would like to seek your permission to avail
          of the tax deduction benefits outlined in the 2024 announcement by the Revenue Department.
          We kindly request your cooperation in consenting to the disclosure of your information to the hotel and
          the Revenue Department for this purpose.
          <br /><br />
          For more detailed information regarding our privacy policy, please refer to
          <a href="https://capellahotelgroup.com/privacy-policy/">https://capellahotelgroup.com/privacy-policy/
          </a>
          <br /><br />
          To proceed with issuing a tax invoice, kindly press "OK."
        </span>
      </div>
    </div>
  <div class="modal-footer p-y-10 d-flex justify-content-center">
    <button class="btn btn-dv btn-clean btn-wide p-x-20 mr-2"
        [disabled]="loading"
        (click)="closePopup()">
      {{ 'CUSTOMER-REQUEST.REJECT' | translate}}
    </button>
    <button class="btn btn-dv btn-wide p-x-20"
        [disabled]="loading"
        (click)="submit()">
      <i *ngIf="loading"
          class="fa fa-spinner fa-spin"></i>
      {{ 'CUSTOMER-REQUEST.OK' | translate}}
    </button>
  </div>
</ng-template>



// WEBPACK FOOTER //
// /opt/app/src/app/features/customer-request/customer-request.component.html